import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { HttpService } from '../../../../shared/services/http/http-client.service';

const API = environment.url_server;

@Injectable({
  providedIn: 'root'
})
export class DetalhePedidoService {

  constructor(private http: HttpService) { }

  listSupplier(data: any, successHandle: Function, errorHandle: Function) {

    this.http.doGet('/enterprise/providerList', data, successHandle, errorHandle);

  }

  moreDetails(params: any, successHandle: Function, errorHandle: Function) {

    this.http.doGet('/enterprise/detailRequestOnline', params, successHandle, errorHandle);

  }

  balanceDetailViewList(data: any, successHandle: Function, errorHandle: Function) {

    this.http.doGet('/enterprise/retailAccountBalance', data, successHandle, errorHandle);

  }

  approvesOnlineSale(data: any, successHandle: Function, errorHandle: Function) {

    return this.http.doPost('/enterprise/approvesOnlineSale', data, successHandle, errorHandle);

  }

  receivablesCerc(data: any, successHandle: Function, errorHandle: Function) {

    this.http.doGet('/enterprise/sumReceivablesCerc', data, successHandle, errorHandle);

  }

  balanceValorRecebiveis(data: any, successHandle:Function, errorHandle:Function) {

    this.http.doGet('/enterprise/returnRetailReceivablesBalance', data, successHandle, errorHandle);

  }

  simulateRetailOnline(data: any, successHandle:Function, errorHandle:Function) {

    this.http.doGet('/enterprise/simulateRetailOnlinePurchase', data, successHandle, errorHandle);

  }


}

